import config from "../_config/config";
import getCookie, { deleteCookie, getReferer, REFERER, URL_PARAMS } from "./cookies";

export function goToLogin(history) {
    // window.location.href = process.env.REACT_APP_LOGIN_URL + "?referer=" + btoa(window.location.href);
    const urlParams = getCookie(URL_PARAMS);
    history.replace("/");
    history.push("/" + urlParams ? `?${urlParams}` : "");
}

export function goToSetPin(history) {
    history.push("/setpin/reset");
}

export function goToEnterPin(history) {
    history.push("/enterpin");
}

export function gotoForgotPassword(history, path) {
    history.push("/forgotpassword/" + (path || ""));
}

export function gotoLoginWithOtp(history, path) {
    history.push("/loginwithotp/" + (path || ""));
}

export function gotoLoginWithTotp(history, path) {
    history.push("/loginwithtotp/" + (path || ""));
}

export function gotoChangePassword(history, path) {
    history.push("/changepassword/" + (path || ""));
}

export function goToDIY(window, params) {
    // let referer = getReferer();
    const endpoint = `${/* (referer && atob(referer)) ||  */config.diyendpoint}${params ? "/?" + params : ""}`;
    window.location.href = endpoint;
}

export const goBackToReferer = (window) => {
    let referer = getReferer();
    referer = referer === "" ? null : referer;
    const tabValue = getCookie('tabValue');
    deleteCookie(REFERER)
    if (tabValue == 1) {
        window.location.href = config.contentendpoint;
    } else {
        window.location.href = (referer && atob(referer)) || config.contentendpoint;
    }
}